import React, { useState,useEffect} from 'react';
import {Link, useParams} from 'react-router-dom';
import MainPagetitle from '../../layouts/MainPagetitle';       
import { Modal,Button } from 'react-bootstrap'; 
import AccountingSystemService from '../../api/services/AccountingSystemService';

const EditAccount = () => { 
    const params = useParams();
    const [error, setError] = useState("")
    const [paymentModal, setPaymentModal] = useState(false);
    const [payment, setPayment] = useState([]);

    useEffect(() => {
      var id = params.id;
      getPaymentByID(id);
    }, []);
    
    const getPaymentByID = async (id) => {
      try {
        let paymetList = await AccountingSystemService.show(id).json();
        setPayment(paymetList.data);
      } catch (error) {
          if (error.name === 'HTTPError') {
              const errorJson = await error.response.json();
              setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
            }
      }
    };
   
      const onSubmitForm = async (event) => {
        event.preventDefault();
        setError("")
        try {
          var userData = {
            "name": event.target.name.value,
            "email": event.target.email.value,
            "status": event.target.status.value,
          
          }
            let responseData = await AccountingSystemService.update(params.id,userData).json()
            if (responseData.status === true) {
                setPaymentModal(true)
            }
          } catch (error) {
            console.log(error)
            if (error.name === 'HTTPError') {
            const errorJson = await error.response.json();
            setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
          }
          }
       
    };

    return(
        <>
          <MainPagetitle mainTitle="Payment Detail" pageTitle={'Payment Detail'} parentTitle={'Home'} /> 
            <div className="container-fluid">
                <div className="row">
			    	<div className="col-xl-12">
                        <div className="card"> 
                            <div className="card-header">
                                <h4 className="card-title">Edit Payment Detail</h4>
                            </div>           
                            <div className="card-body">
                                <form className="form-valide" onSubmit={onSubmitForm}>
                                    <div className="row">
                                      {error && <h5 style={{color:'red'}}>{error}</h5>}
                                        <div className="col-xl-12 mb-3">
                                            <label htmlFor="val-username" className="form-label" >First & Last Name<span className="text-danger">*</span></label>
                                            <input type="text" className="form-control" name='title' id="val-username"
                                            defaultValue={
                                                    payment.name
                                                    ?  payment.name
                                                    : ''
                                                }/>
                                        </div>	
                                        <div className="col-xl-12 mb-3">
                                            <label htmlFor="val-username" className="form-label" >Email<span className="text-danger">*</span></label>
                                            <input type="email" className="form-control" name='email' id="val-username"
                                            defaultValue={
                                                    payment.email
                                                    ?  payment.email
                                                    : ''
                                                }/>
                                        </div>	
                                        <div className="col-xl-12 mb-3">
                                            <label htmlFor="val-username" className="form-label" >Status<span className="text-danger">*</span></label>
                                            <input type="status" className="form-control" name='status' id="val-username"
                                            defaultValue={
                                                    payment.status
                                                    ?  payment.status
                                                    : ''
                                                }/>
                                        </div>	
                                      
                                    </div>
                                    <h5 style={{color:'red'}}>{error}</h5>
                                    <div>
                                        <button type="submit" className="btn btn-primary mb-2 me-1"  >Submit</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal centered className="mark-attendence" show={paymentModal}>
            <Modal.Header>
              <Modal.Title>Update </Modal.Title>
              <Button variant="" className="btn-close" onClick={() => setPaymentModal(false)}></Button>
            </Modal.Header>
            <Modal.Body>Update Service Successfully!!!.</Modal.Body>
            <Modal.Footer>
              <Link className="btn btn-primary" to={'/admin/brand'} variant="danger light" onClick={() => setPaymentModal(false)}>Close</Link>
            </Modal.Footer>
          </Modal>
        </>
    );
};
export default EditAccount;